import { Component, OnInit } from '@angular/core';

interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-opsdisputes',
  templateUrl: './opsdisputes.component.html',
  styleUrls: ['./opsdisputes.component.css']
})
export class OpsdisputesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    { value: 'RETRIEVAL-1', viewValue: 'RETRIEVAL' },
    { value: 'CHARGEBACK-2', viewValue: 'CHARGEBACK' },
    { value: 'PRE-ARB-3', viewValue: 'PRE-ARB' },
    
  ];

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }

}
